module.exports = __webpack_public_path__ + "img/finance-4.31d7ecb5.jpg";